export class GroupOriginRequest { 
    public idGroupOrigin: number;
    public groupOriginName: string;
    public listIdOrigin: number[] = [];
    public listIdArrivalType: number[] = [];
}